import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BusService } from '../../../services/bus.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Bus } from '../../../model/bus';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { BusManageDialogResponse } from '../busses.component';
import {
  ColDef, GridOptions, GridReadyEvent, NewValueParams} from 'ag-grid-community';
import * as moment from 'moment';
import { BtnDeleteCellRenderer } from '../../button-delete-cell-renderer.component';
import { ServiceLocator } from '../../../services/service.locator';
import { ServiceTypes } from '../../../common/enums';
import { ConfirmDialog } from '../../../confirmation/confirm.dialog';

@Component({
  selector: 'app-manage-bus',
  templateUrl: './manage-bus.component.html',
  styleUrls: ['./manage-bus.component.css']
})
export class ManageBusComponent implements OnInit {
  public form: UntypedFormGroup;
  public serviceFormGroup: UntypedFormGroup;
  public typesFormControl: UntypedFormControl;
  public fuelTypesFormControl: UntypedFormControl;
  public serviceTypeFc: UntypedFormControl;
  public serviceDateFc: UntypedFormControl;
  public showAllFc: UntypedFormControl;
  public serviceDescriptionFc: UntypedFormControl;
  public typeValues: string[] = [];
  public fuelTypeValues: string[] = ['Gas', 'El'];
  public serviceTypeValues: string[] = ['Repair', 'Wash'];
  public newBus: boolean;
  public serviceData: Service[] = []
  public allServiceData: Service[] = []
  
  private readonly selectedBus: Bus;
  private closeResponse: BusManageDialogResponse;
  private confirmModalRef: MatDialogRef<ConfirmDialog>;
  public showAll: boolean = false;


  public columnDefs: ColDef[] = [
    {
      field: "id", editable: false, hide: true
    },
    {
      field: "performed",hide: false, headerName: "Utförd", width: 100,
      editable: params => {
        return !params.data.performed
      },
      onCellValueChanged: (valueParams: NewValueParams) => {
        this.onDoneCellClicked(valueParams);
      }
    },
    {
      field: "start", editable: true, hide: false, headerName: "När", width: 150,

      cellRenderer: (data) => {
        return moment(data.value).format('YYYY-MM-DD');
      }
    },
    {
      field: "type", editable: false, hide: false, headerName: "Typ", width: 120,
      cellRenderer: (data) => {
        let type: string = data.value as string;
        return ServiceTypes[type.toLowerCase()];
      }
    },
    {
      field: "description", editable: false, hide: false, headerName: "Besk."
    },
    {

      field: "", editable: false, hide: false, width: 100,
      cellRendererSelector: params => {
        return {
          component: BtnDeleteCellRenderer,
          params: { clicked: this.buttonServiceDeleteCallback, self: this }
        };
      }
    }
  ];

  public gridOptions: GridOptions = {
    suppressHorizontalScroll: true,
    headerHeight: 32,
    rowSelection: "single",
    onGridReady: (event: GridReadyEvent) => this.onGridReady(event),
    columnDefs: this.columnDefs
  };

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
    public dialogRef: MatDialogRef<ManageBusComponent>,
    private readonly fb: UntypedFormBuilder,
    private readonly busService: BusService,
    private readonly toastr: ToastrService
    ) {

    this.selectedBus = this.data.bus as Bus;
    this.newBus = this.selectedBus === undefined;

    if (this.newBus) {
      this.createNewFormControl();
    }
    else {
      this.createEditFormControl()


    }
    this.createServiceFormControl();

  }

  private createServiceFormControl() {
    this.serviceTypeFc = new UntypedFormControl(Validators.required);
    this.serviceDateFc = new UntypedFormControl(Validators.required);
    this.serviceDescriptionFc = new UntypedFormControl("", Validators.required);
    this.showAllFc= new UntypedFormControl(this.showAll);
    this.serviceFormGroup = this.fb.group({
      type: this.serviceTypeFc,
      date: this.serviceDateFc,
      description: this.serviceDescriptionFc,
      showAll: this.showAllFc
    })
  }

  private createEditFormControl() {
    this.typesFormControl = new UntypedFormControl(this.selectedBus.busType, Validators.required);
    this.fuelTypesFormControl = new UntypedFormControl(this.selectedBus.fuel, Validators.required);
    this.form = this.fb.group({
      registrationNumber: new UntypedFormControl(this.selectedBus.registrationNumber, Validators.required),
      number: new UntypedFormControl(this.selectedBus.number, Validators.required),
      types: this.typesFormControl,
      fuel: this.fuelTypesFormControl,
      active: new UntypedFormControl({ value: this.selectedBus.active, disabled: false }),
    });
  }

  private createNewFormControl() {
    this.typesFormControl = new UntypedFormControl("", Validators.required);
    this.fuelTypesFormControl = new UntypedFormControl("", Validators.required);
    this.form = this.fb.group({
      registrationNumber: new UntypedFormControl("", Validators.required),
      number: new UntypedFormControl("", Validators.required),
      types: this.typesFormControl,
      fuel: this.fuelTypesFormControl,
      active: new UntypedFormControl({ value: true, disabled: false }),
    })
  }

  onDoneCellClicked(valueParams: NewValueParams) {
    this.busService.updateServiceAsDone(valueParams.data.id)
      .then(res => {
        let updatedService = this.serviceData.find(s => s.id === valueParams.data.id);
        updatedService.end = res.end;

        this.createCloseResponse();

        this.toastr.success("Servicen markerad som avklarad.");
      })
      .catch(error => { this.toastr.error("Det gick inte att uppdatera service"); });
  }

  onGridReady(event: GridReadyEvent) {
    event.api.sizeColumnsToFit();
  }

  ngOnInit(): void {

    this.dialogRef.beforeClosed().subscribe(() => {
      this.dialogRef.close(this.closeResponse);
    });

    if (!this.newBus) {
      this.busService.getBusServices(this.selectedBus.id).then((services: Service[]) => {
        this.allServiceData = Service.ToTypeSafeList(services);
        this.sortServices();
      });
    }

    this.busService.getAllBusTypes()
      .then((types: string[]) => {
        this.typeValues = types;

        this.sortServices();
      })
      .catch(error => console.error(error));

  }

  canSave() {
    return this.form.valid && this.form.dirty;
  }

  canDelete() {
    return !this.newBus;
  }

  submit() {
    console.log(this.form);
    if (this.form.valid) {
      let bus: Bus = new Bus();
      if (!this.newBus) {
        bus.id = this.selectedBus.id;
      }

      bus.active = this.form.controls.active.value;
      bus.busType = this.typesFormControl.value;
      bus.fuel = this.fuelTypesFormControl.value;
      bus.number = this.form.controls.number.value;
      bus.registrationNumber = this.form.controls.registrationNumber.value;

      if (this.newBus) {
        this.createBus(bus);
      }
      else {
        this.updateBus(bus);
      }
    }
  }

  deleteBus() {

    this.confirmModalRef = ServiceLocator.dialog.open(ConfirmDialog, {
      disableClose: false,
      width: "400px",
      autoFocus: false,
      closeOnNavigation: false, data:
      {
        id: 1,
        title: "Bekräfta",
        text: "Vill du verkligen radera buss: " + this.selectedBus.number
      }
    });

    this.confirmModalRef.afterClosed().subscribe(result => {
      if (result) {
        this.busService.deleteBus(this.selectedBus)
          .then(res => {
            this.toastr.success("Buss " + this.selectedBus.number + " är raderad")
            this.closeResponse = new BusManageDialogResponse();
            this.closeResponse.bus = this.selectedBus;
            this.closeResponse.deleted = true;
            this.dialogRef.close(this.closeResponse);
          })
          .catch((error: HttpErrorResponse) => {
            if (typeof error.error == 'string') {
              this.toastr.error(error.error, "Fel när buss " + this.selectedBus.number + " skulle raderas");
            }
            else {
              this.toastr.error(error.message, "Fel när buss " + this.selectedBus.number + " skulle raderas");
            }

          });

      }
    });
  }

  buttonServiceDeleteCallback(buttonScope): void {
    this.confirmModalRef = ServiceLocator.dialog.open(ConfirmDialog, {
      disableClose: false,
      width: "400px",
      autoFocus: false,
      closeOnNavigation: false, data:
      {
        id: 2,
        title: "Bekräfta",
        text: "Vill du verkligen radera servicen?"
      }
    });

    this.confirmModalRef.afterClosed().subscribe(result => {
      if (result) {
        let id = buttonScope.params.data.id;

        ServiceLocator.busService.deleteServiceForBus(id)
          .then(result => {
            let index = buttonScope.params.self.allServiceData.findIndex(s => s.id == id)
            buttonScope.params.self.allServiceData.splice(index, 1);
            buttonScope.params.self.allServiceData = [...buttonScope.params.self.allServiceData];

            buttonScope.params.self.filterServices();

            buttonScope.params.self.createCloseResponse();

            ServiceLocator.toastr.success("Service borttagen från bus")
          })
          .catch(error => {
            console.log(error);
            this.toastr.error(error, "Det gick inte att ta bort servicen!");
          });
      }
    });
    
  }

  serviceIsValid() {
    return this.serviceFormGroup.valid && this.serviceFormGroup.dirty;
  }

  addService() : void {

    if (this.selectedBus === undefined) {
      this.toastr.error("Det går inte att lägga till en service förrän den nya bussen blivit sparad");
      return;
    }

    let newBusServiceDto = new BusServiceDto();
    newBusServiceDto.performed = false;
    newBusServiceDto.start = this.serviceDateFc.value;
    newBusServiceDto.description = this.serviceDescriptionFc.value;

    newBusServiceDto.type = this.getServiceTypeDefByVal(this.serviceTypeFc.value);

    newBusServiceDto.busId = this.selectedBus.id;
    this.busService.addServiceForBus(newBusServiceDto).then((service: Service) => {
      let typeSafeService = Service.ToTypeSafe(service);
      this.allServiceData = this.allServiceData.concat([typeSafeService]);

      this.createCloseResponse();      

      this.sortServices();      
      this.clearServiceForm();

      if (service.statusMessage !== undefined) {
        this.toastr.warning(service.statusMessage);
      }

      this.toastr.success("Bus uppdaterad med ny service!")
    }).catch(error => this.toastr.error("Det gick inte att lägga till service på bus"))
  }

  allServiceTypes(): string[] {
    let names: string[] = [];
    for (let type in ServiceTypes) {
      names.push(ServiceTypes[type]);
    }
    return names;
  }

  private updateBus(bus: Bus) : void{
    this.busService.updateBus(bus)
      .then((updatedBus: Bus) => {
        this.toastr.success('Bus ' + updatedBus.number + ' uppdaterad!');
        this.closeResponse = new BusManageDialogResponse();

        this.selectedBus.active = updatedBus.active;
        this.selectedBus.busType = updatedBus.busType;
        this.selectedBus.fuel = updatedBus.fuel;
        this.selectedBus.number = updatedBus.number;
        this.selectedBus.onService = updatedBus.onService;
        this.selectedBus.registrationNumber = updatedBus.registrationNumber;
        this.selectedBus.serviceDescription = updatedBus.serviceDescription;

        this.createCloseResponse();

        this.dialogRef.close(this.closeResponse);

      })
      .catch((error: HttpErrorResponse) => {
        if (typeof error.error === 'string') {
          this.toastr.error(error.error, 'Det gick inte att uppdatera ' + this.selectedBus.number);
        }
        else {
          this.toastr.error(error.error.title, 'Det gick inte att uppdatera ' + this.selectedBus.number);
        }

      });
  }

  private createBus(bus: Bus) : void {
    this.busService.createBus(bus)
      .then((newBus: Bus) => {
        this.toastr.success('Bus ' + newBus.number + ' skapad!');
        this.closeResponse = new BusManageDialogResponse();
        this.closeResponse.bus = newBus;
        this.closeResponse.created = true;
        this.dialogRef.close(this.closeResponse);
      })
      .catch((error: HttpErrorResponse) => {
        if (typeof error.error === 'string') {
          this.toastr.error(error.error, 'Det gick inte att uppdatera ' + this.selectedBus.number);
        }
        else {
          this.toastr.error(error.error.title, 'Det gick inte att uppdatera ' + this.selectedBus.number);
        }

      });
  }

  private getServiceTypeDefByVal(value: string): string {
    for (let def in ServiceTypes) {
      if (ServiceTypes[def] === value) {
        return def;
      }
    }
  }

  private sortServices(): void {
    this.filterServices();
    this.serviceData.sort((s1: Service, s2: Service) => {
      if ((s1.performed && s2.performed) || (!s1.performed && !s2.performed)) {
        if (s1.start.getTime() < s2.start.getTime()) {
          return -1;
        }
        return 1;
      }
      else if (s2.performed) {
        return -1;
      }
    });
    
  }

  public showAllClick() {
    this.showAll = !this.showAll;
    this.filterServices();
  }

  private filterServices(): void {
    if (!this.showAll) {
      this.serviceData = this.allServiceData.filter(service => !service.performed);
    }
    else {
      this.serviceData = this.allServiceData;
    }
    
  }

  private clearServiceForm() : void {
    this.serviceFormGroup.reset();
  }

  private createCloseResponse(): void {
    this.closeResponse = new BusManageDialogResponse();
    this.selectedBus.serviceDescription = this.allServiceData.filter(s => s.isOnService).map(c => c.description).join(", ");

    this.selectedBus.onService = this.allServiceData.filter(s => s.isOnService).length > 0;

    this.closeResponse.bus = this.selectedBus;
  }

}

export class Service {
  id: number;
  performed: boolean;
  description: string;
  type: string;
  start: Date;
  end: Date;
  statusMessage: string;

  get isOnService() : boolean {
    if (this.start !== undefined && this.start.getTime() <= new Date().getTime() && this.end === undefined) {
      return true;
    }
    return false;
  }

  public static ToTypeSafe(service: Service): Service {
    let typeSafeService = new Service()
    typeSafeService.id = service.id;
    typeSafeService.start = new Date(service.start);
    typeSafeService.end = service.end === undefined ? undefined: new Date(service.end);
    typeSafeService.performed = service.end !== undefined;
    typeSafeService.description = service.description;
    typeSafeService.type = service.type;
    typeSafeService.statusMessage = service.statusMessage;
    return typeSafeService;
  }

  public static ToTypeSafeList(services: Service[]): Service[] {
    return services.map((s) => { return Service.ToTypeSafe(s); });
  }
}

export class BusServiceDto extends Service
{
  busId: string;
}

